<template>
  <div class="container"
       id="con">
    <h3>{{title}}</h3>
    <!-- <van-button type="primary"
                @click="onshow">弹出图片</van-button> -->
    <p v-html="text"></p>
    <van-image-preview v-model="show"
                       :showIndex="false"
                       :images="images"
                       @change="onChange">
    </van-image-preview>

  </div>
</template>

<script>
import http from '../utils/http.js';
export default {
  name: 'HelloWorld',
  data () {
    return {
      id: "",
      text: " ",
      title: "",
      show: false,
      index: 0,
      images: []
    }
  },
  created () {
    this.id = this.$route.params.id;
    this.title = this.$route.query.name;

  },
  mounted () {
    let name = this.$route.query.name;
    document.title = "刷机帮助" + "-" + name;
    this.getData();
    let that = this;
    let con = document.getElementById("con");
    con.addEventListener("click", function () {
      let ev = ev || window.event;
      let target = ev.target || ev.srcElement;
      if (target.nodeName.toLowerCase() == "img") {
        that.images = [target.src];
        console.log(that.images);
        that.show = true;

      }
    });
  },
  methods: {
    onshow () {
      this.show = true;
    },
    // 文章详情
    getData () {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      var url = "/feedback/questionanswer";
      var params = {
        newsId: this.id,
      }
      http.get(url, params).then(res => {
        this.$toast.clear();
        if (res.data.code === 0) {
          this.text = res.data.data[0].name;
        } else {
          this.$toast("暂无数据");
        }
      })
    },
    onChange (index) {
      this.index = index;
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped>
.container {
  padding: 20px 16px;
  line-height: 24px;
  text-align: left;
  overflow-x: hidden;
  color: #333;
}
.container >>> img {
  display: inline-block;
  width: 100%;
  /* width: 100vw; */
  /* margin: 0 -16px; */
}
.container >>> .van-image img {
  width: 100vw;
  margin: 0 -16px;
}
.container h3 {
  font-size: 20px;
  line-height: 30px;
  padding-bottom: 16px;
  word-break: break-all;
}
.container >>> p {
  margin-bottom: 20px;
  line-height: 26px;
  text-align: left;
  font-size: 16px;
}
.title {
  color: #333;
}
.container >>> .van-image {
  margin: 16px;
}
.container >>> iframe {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/desc.vue